import { CustomerType, IraAccountType } from '../../../../Apex/ApexConstants';

export const getAccountTypeTitle = (accountType: CustomerType, iraType: IraAccountType | null) => {
  switch (accountType) {
    case CustomerType.Individual:
      return 'Individual Investment Account';
    case CustomerType.Ira:
      switch (iraType) {
        case IraAccountType.TraditionalIra:
          return 'Traditional IRA Investment Account';
        case IraAccountType.RolloverIra:
          return 'Rollover IRA Investment Account';
        case IraAccountType.SepIra:
          return 'Sep IRA Investment Account';
        case IraAccountType.RothIra:
          return 'Roth IRA Investment Account';
        case IraAccountType.SimpleIraParticipant:
          return 'Simple IRA Investment Account';
        default:
          return 'Investment Account';
      }
    case CustomerType.Joint:
      return 'Joint Investment Account';
    default:
      return 'Investment Account';
  }
};
